import { useRouter } from 'next/router';
import CardForm2 from './components/CardForm2';
import styles from './styles.module.css';
import { GetWLData } from '../../services/wl';
import { GetInfos } from '../../services/endpoints/information/GetInformationService';
import { filterObjectByKeys } from '../../functions/filterObject';

export default function CalculadoraDesconto(props) {
  const router = useRouter();
  const version = router.query.v;
  const isApp = router.query.app == 1;

  // const [textArr, setTextArr] = useState([]);

  // useEffect(() => {
  //   setTextArr(marked.parse(props.infos.texto_test_2).split('\\n') ?? []);
  // });
  return (
    <div className={`${styles.container} ${isApp ? styles.full : ''}`}>
      <CardForm2 full={isApp} wl={props.wl} infos={props.infos} isApp={isApp} defaultOwner={props.defaultOwner??'-'} />
    </div>
  );
}

export async function getStaticProps(context) {
  const result = await GetWLData();

  if (!result.status) {
    return {
      redirect: {
        permanent: false,
        destination: '/error?tag_error=white_label',
      },
      props: {},
      revalidate: 60 * 10,
    };
  }

  const infos = await GetInfos().then(
    (data) => {
      
      if(data?.data?.[0]?.attributes) {
        return filterObjectByKeys(data?.data?.[0]?.attributes, ['usar_cupom_desconto', 'usa_sharpspring']);
      } else {
        return false;
      }
    }
  );

  return {
    props: {
      infos,
      wl: result.data
    },
    revalidate: 60 * 10,// renovar a cada 10m: usuário sempre acessará um cache
  };
}
